export default __webpack_public_path__ + "static/media/play-icon-blue.3934abfb.svg";